import { getIn } from 'seamless-immutable';
import { ApolloLink } from '@apollo/client';

export default req =>
  new ApolloLink((operation, forward) =>
    forward(operation).map(data => {
      const errors = getIn(data, ['errors']);
      const message = getIn(errors, [0, 'message'], '');
      const isBrowser = typeof window !== 'undefined';

      if (message.indexOf('fetchJSON: Not Found') > -1) {
        return data;
      }

      if (!isBrowser && errors) {
        req.graphqlErrors.push(errors);

        console.error(JSON.stringify(errors));
      }

      return data;
    })
  );
